var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.svg,{tag:"component",staticClass:"vgtc-svg-icon",class:{'vgtc-svg-icon--fill':_vm.fill}})
}
var staticRenderFns = []

export { render, staticRenderFns }